import React, {useEffect, useState} from 'react';
import {Avatar, Input} from "@material-tailwind/react";
import {BsDownload, BsUpload} from "react-icons/bs";
import {getFileUrl, getThumbUrl} from "../../config";
import {getFileNameByCode} from "../../services/file/file";

const FileInput = ({classes, id, onChange, label, fileCode}) => {
  const [fileName, setFileName] = useState('فایلی انتخاب نشده است');
  const [hovered, setHovered] = useState(false);
  const [thumb, setThumb] = useState("")

  useEffect(() => {
    async function getData() {
      if (fileCode.length > 0) {
        const result = await getFileNameByCode(fileCode);
        if (result.status === 200) {
          const {file_name} = result.data;
          setFileName(file_name || []);
        }
      }
    }

    if (fileCode) {
      getData()
    }
  }, [fileCode]);

  useEffect(() => {
    // if (fileCode && fileCode.length > 0) {
    async function getData() {
      const result = await getThumbUrl(fileCode);
      setThumb(result);
    }

    getData()
    // }
  }, [fileCode]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFileName(file.name);
    onChange && onChange(e);
  };

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <div className={`flex items-center justify-center w-fit ${classes}`}>
      <label htmlFor={id}
             className="relative cursor-pointer align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-4 rounded-lg border border-gray-900 text-gray-900 hover:opacity-75 focus:ring focus:ring-gray-300 active:opacity-[0.85] flex-shrink-0">
        <div className="flex flex-row">
          <BsUpload size={16} fontSize="sm"/>
          <div className="mr-2">
            {label}
          </div>
        </div>

        <input id={id} type="file" className="hidden" onChange={handleFileChange}/>
      </label>
      <Input className="mx-4" variant="standard" readOnly={true} value={fileName}/>
      <div className="pr-4 min-w-16">
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{position: 'relative'}}
        >
          {fileCode?.length > 0 &&
            <>
              <Avatar
                src={thumb}
                alt="فایل"
                className="mx-2"
                style={{cursor: 'pointer', filter: hovered ? 'blur(2px)' : 'none'}}
                variant="rounded"
                size="md"
              />
              {hovered && (
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-70%, -50%)',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    borderRadius: '50%',
                    padding: '8px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    window.open(getFileUrl(fileCode), '_blank');
                  }}
                >
                  <BsDownload size={24}/>
                </div>
              )}
            </>
          }
        </div>
      </div>

    </div>
  );
};

export default FileInput;
